module.exports = __webpack_public_path__ + "img/ring_g_c_0_null@3x.aeb48f88.png";